import { CloseWebviewEvent } from '../../sdk/close.webview.event';

export const EnterAmountType = {
  P2P: 'P2P',
  MICROLOAN: 'MICROLOAN',
  MICROLOAN_PAYMENT: 'MICROLOAN_PAYMENT',
  POS: 'BASATA_TOP_UP_POS',
  SEND_MONEY_TO_COMPANY: 'SEND_MONEY_TO_COMPANY',
};

export const EnterAmountProvider = (t, type) => {
  switch (type) {
    case EnterAmountType.P2P: {
      return {
        title: t('Send money'),
      };
    }

    case EnterAmountType.MICROLOAN: {
      return {
        title: t('Use credit'),
      };
    }

    case EnterAmountType.MICROLOAN_PAYMENT: {
      return {
        title: t('Pay installments'),
      };
    }
    case EnterAmountType.POS: {
      return {
        title: t('Top up POS'),
      };
    }

    case EnterAmountType.SEND_MONEY_TO_COMPANY: {
      return {
        title: t('Send money to Company'),
      };
    }

    default:
      return {};
  }
};
